<template>
  <div class="school_designer">
    <div class="breadbox m">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/school_list' }">明星院校</el-breadcrumb-item>
        <el-breadcrumb-item>{{params.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="school_info">
      <div class="box m">
        <div class="left_img">
          <img :src="params.coverPath" alt="">
        </div>
        <div class="right_txt">
          <div class="top_name">
            <h3>
              {{params.name}}
              <el-tooltip effect="light" content="在展官方认证" placement="top">
                <span>认证</span>
              </el-tooltip>
            </h3>
            <a :href="params.website" target="_blank">院校主页 <i class="el-icon-arrow-right"></i></a>
          </div>
          <h4>{{params.synopsis}}</h4>
        </div>
      </div>
    </div>
    <div class="filtrate">
      <div class="filtrate_box m">
        <ul class="filtrate_box_l">
          <li>
            <router-link :to="'/school_exhibition?id='+searchObj.school">
              展览(<span>{{params.total_exhibition}}</span>)
            </router-link>
          </li>
          <li>
            <router-link :to="'/school_student?id='+searchObj.school">
              学生(<span>{{params.total_student}}</span>)
            </router-link>
          </li>
          <li class="active">
            <router-link :to="'/school_teacher?id='+searchObj.school">
              教师(<span>{{params.total_teacher}}</span>)
            </router-link>
          </li>
          <li>
            <router-link :to="'/school_vr?id='+searchObj.school">
              VR(<span>{{params.total_pavilion||0}}</span>)
            </router-link>
          </li>
        </ul>
        <div class="filtrate_box_r">
          <el-input
              class="input_class"
              placeholder="请输入内容"
              v-model="searchObj.name"
              style="width:180px;"
              @keyup.native.enter="search">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
    </div>
    <div class="m">
      <template v-if="layerpageinfo.total > 0">
        <div class="school_index_page_b">
          <!-- 每个设计师 -->
          <teacher_list
              v-for="(item, index) in list"
              :key="index"
              :index="index"
              :mini_flag="false"
              :designer_obj="item"
          ></teacher_list>
        </div>
        <!-- 分页 -->
        <div class="page_box">
          <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
        </div>
      </template>
      <!-- 为空 -->
      <div class="no_list" v-else></div>
    </div>
  </div>
</template>

<script>
  import teacher_list from "@/components/list_item/teacher_list/teacher_list.vue";
  import myPage from "@/components/myPage/myPage";
  export default {
    components:{
      teacher_list,
      myPage
    },
    data(){
      return{
        params:{},
        layerpageinfo:{
          pageNo: 0,
          pageSize: 6,
          total: 0
        },
        searchObj:{
          school: this.$route.query.id,
          name: ''
        },
        list: []
      }
    },
    created() {
      this.getData();
      this.getList();
    },
    methods:{
      // 页数切换
      changePage(pageNo) {
        this.layerpageinfo.pageNo = pageNo;
        this.getList();
      },
      search(){
        this.layerpageinfo.pageNo = 0;
        this.getList();
      },
      //查询设计师列表
      getList(){
        let params = {
          ...this.layerpageinfo,
          ...this.searchObj,
          is_teacher: true
        }
        this.api.getFrontTeachers(params).then(res=>{
          if(res.error['err_code'] !== 0) return;
          this.list = res.obj.list;
          this.layerpageinfo.total = res.obj.totalSize;
        })
      },
      //查询学校
      getData(){
        this.api
            .getFrontSchools({
              id: this.$route.query.id
            })
            .then(res => {
              if (res.error.err_code !== 0) return;
              this.params = res.obj.list[0] || {};
            });
      },
    }
  }
</script>

<style lang="scss">
  .school_designer{

  }
</style>
